module.exports = __webpack_public_path__ + "img/wbicon-panyu.ab1573ce.jpg";